import { Routes } from '@angular/router';
import { HomeComponent } from './features/home/pages/home.component';
import { contactComponent } from './features/contact/pages/contact.component';
import { SaberMasComponent } from './features/sabermas/sabermas.component';
import { ServiciosComponent } from './features/servicios/servicios.component';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent, //AppComponent,
    pathMatch: 'full',
  },
  {
    path: 'contact',
    component: contactComponent, 
    pathMatch: 'full',
  },
  {
    path: 'system',
    loadChildren: () => import('./features/systems/systems.route')
  },
  {
    path: 'saberMas',
    component: SaberMasComponent,
    pathMatch: 'full',
  },
  {
    path: 'servicios',
    component: ServiciosComponent,
    pathMatch: 'full',
  },
];
